<template>
  <div class="container" layout="row center-left">
    <div class="logo">
      Smart Roadshow
    </div>
    <div class="navigation" layout="row center-left">
      <router-link to="/dashboard" class="nav" :class="{ selected: item == 1 }"><i class="fas fa-h-square"></i></router-link>
      <router-link to="/cities" class="nav" :class="{ selected: item == 2 }">Städte</router-link>
      <router-link to="/maps" class="nav" :class="{ selected: item == 3 }">Karten</router-link>
      <router-link to="/cms" class="nav" :class="{ selected: item == 4 }">CMS</router-link>
      <router-link to="/quiz" class="nav" :class="{ selected: item == 5 }">Quiz</router-link>
      <router-link to="/instagram" class="nav" :class="{ selected: item == 6 }">Instagram</router-link>
      <router-link to="/settings" class="nav" :class="{ selected: item == 7 }">Settings</router-link>
      <router-link to="/update" v-if="isDev" class="nav" :class="{ selected: item == 8 }">Update</router-link>
    </div>
  </div>
</template>

<script>
  import Utils from '@/Utils';

  export default {
    name: "navbar",
    props: ['item'],
    data() {
      return {
        isDev: Utils.isDevEnvironment()
      }
    },
    methods: {
    }
  }
</script>

<style scoped>
  .container {
    height: 40px;
    background-color: black;
    color: white;
    padding-left: 1rem;
    font-weight: lighter;
    /*position: absolute;*/
  }

  .logo {
    width: 280px;
    font-weight: bold;
    font-size: 1.5rem;
  }

  .navigation {

  }

  a {
    text-decoration: none;
    color: white;
  / / font-weight: 400;
  }

  .nav {
    margin-right: 1rem;
  }

  .selected {
    font-weight: bold;
  }

</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue